"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var Autosuggest = require("react-autosuggest");
var pp_react_1 = require("@paypalcorp/pp-react");
var pp_react_checkbox_1 = require("@paypalcorp/pp-react-checkbox");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var addressErrors_1 = require("../../../utils/errorcodes/addressErrors");
var constants_1 = require("../../../constants");
var interpolate_component_1 = require("../../../components/interpolate-component");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS, FPTI = constants_1.default.FPTI;
var commonweb_utils_1 = require("commonweb-utils");
var addresses_1 = require("../../../actions/addresses");
var modalHeader_1 = require("../../../actions/modalHeader");
var page = require("page");
/**
 * Update address component
 * @author pkatoria
 */
var UpdateAddress = /** @class */ (function (_super) {
    tslib_1.__extends(UpdateAddress, _super);
    function UpdateAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.billingAddressInfo = function () {
            var walletUrl = _this.props.links.wallet.linkUrl, cards = "", cardList = _this.state.addressToUpdate.cardList;
            var billingInfoContent;
            var count = 1;
            if (cardList) {
                cardList.forEach(function (card) {
                    if (card.fullName) {
                        if (count > 1) {
                            cards = cards + ", ";
                        }
                        cards =
                            cards + card.fullName + " ( ••••" + card.lastFour + ")";
                        count++;
                    }
                });
            }
            if (cardList) {
                if (_this.state.addressToUpdate.paypalCredit) {
                    billingInfoContent = _this.props.addressContent.info
                        .paypalCreditWithCards;
                }
                else {
                    billingInfoContent = _this.props.addressContent.info.cards;
                }
            }
            else if (_this.state.addressToUpdate.paypalCredit) {
                billingInfoContent = _this.props.addressContent.info.paypalCredit;
            }
            var walletLinkComponent = (React.createElement(pp_react_1.Link, { key: _this.props.addressContent.walletLink, href: walletUrl }, _this.props.addressContent.walletLink));
            var cardsContent = interpolate_component_1.InterpolateLinksWithComponent(billingInfoContent, [
                cards,
                walletLinkComponent,
            ]);
            return cardsContent;
        };
        _this.getErrorContent = function (errorContent) {
            var customerCareUrl = _this.props.links.help.linkUrl;
            var ccLinkComponent = (React.createElement(pp_react_1.Link, { key: _this.props.commonContent.customerCareLink, href: customerCareUrl }, _this.props.commonContent.customerCareLink));
            var convertedErrorContent = interpolate_component_1.InterpolateLinksWithComponent(errorContent, [ccLinkComponent]);
            return convertedErrorContent;
        };
        _this.inputChangedHandler = function (event, formInputIdentifier) {
            if (!_this.state.formChanged) {
                _this.setState({ formChanged: true });
            }
            var updatedForm = tslib_1.__assign({}, _this.state.form);
            var updatedFormElement = tslib_1.__assign({}, updatedForm[formInputIdentifier]);
            updatedFormElement.value =
                event.target.type === "checkbox"
                    ? !updatedFormElement.value
                    : event.target.value;
            updatedFormElement.isValid = _this.checkValidity(updatedFormElement.value, updatedFormElement.validation);
            updatedFormElement.isTouched = true;
            updatedForm[formInputIdentifier] = updatedFormElement;
            var formIsValid = true;
            for (var inputIdentifier in updatedForm) {
                formIsValid = updatedForm[inputIdentifier].isValid && formIsValid;
            }
            _this.setState({ form: updatedForm, formIsValid: formIsValid });
        };
        // start : SearcBox related functions
        _this.onChange = function (event, _a) {
            var newValue = _a.newValue, method = _a.method;
            if (method !== "click") {
                _this.setState({
                    value: newValue,
                });
            }
            else {
                if (method === "click") {
                    _this.passValueToDropdown(newValue);
                }
            }
        };
        _this.passValueToDropdown = function (newValue) {
            var selectedState = _this.props.stateList.find(function (state) { return state.$elt === newValue; });
            var updatedForm = tslib_1.__assign({}, _this.state.form);
            var updatedFormElement = tslib_1.__assign({}, updatedForm["state"]);
            updatedFormElement.value = selectedState.$id;
            updatedFormElement.isValid = true;
            updatedForm["state"] = updatedFormElement;
            var formIsValid = true;
            for (var inputIdentifier in updatedForm) {
                formIsValid = updatedForm[inputIdentifier].isValid && formIsValid;
            }
            _this.setState({
                form: updatedForm,
                formIsValid: formIsValid,
                openListPage: false,
                value: selectedState.$elt,
                label: selectedState.$elt,
            });
            _this.props.changeHeaderVisibility(true);
        };
        _this.toggleListPageVisibility = function () {
            _this.setState({
                openListPage: !_this.state.openListPage,
            });
            _this.props.changeHeaderVisibility(!_this.props.showNavigation);
        };
        // Autosuggest will call this function every time you need to update suggestions.
        // You already implemented this logic above, so just use it.
        _this.onSuggestionsFetchRequested = function (_a) {
            var value = _a.value;
            _this.setState({
                suggestions: _this.getSuggestions(value),
            });
        };
        // Teach Autosuggest how to calculate suggestions for any given input value.
        _this.getSuggestions = function (value) {
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            return inputLength === 0
                ? _this.props.stateList
                : _this.props.stateList.filter(function (state) {
                    return state.$elt.toLowerCase().slice(0, inputLength) ===
                        inputValue;
                });
        };
        // When suggestion is clicked, Autosuggest needs to populate the input
        // based on the clicked suggestion.
        _this.getSuggestionValue = function (suggestion) { return suggestion.$elt; };
        // render suggestions.
        _this.renderSuggestion = function (suggestion) { return (React.createElement("div", { className: "listItem" },
            React.createElement(pp_react_1.Text, { size: "md" }, suggestion.$elt))); };
        _this.renderInput = function (inputProps) { return (React.createElement("div", null,
            React.createElement(pp_react_1.TextInput, tslib_1.__assign({ name: "help", value: "", label: "Search State", leftIcon: React.createElement(pp_react_1.Icon, { size: "sm", name: "search" }) }, inputProps)))); };
        // end : SearcBox related functions
        _this.submitHandler = function (event) {
            event.preventDefault();
            if (_this.state.formIsValid || !_this.state.formChanged) {
                _this.setState({ showSpinner: true });
                var formData = {};
                for (var formElementIdentifier in _this.state.form) {
                    formData[formElementIdentifier] = _this.state.form[formElementIdentifier].value;
                }
                formData["id"] = _this.props.route.enter.params.id;
                formData["addresses"] = _this.props.addressData.addresses;
                ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + ROUTES.API.ADDRESSES.EDIT, formData, { component: { name: VIEWS.ADDRESSES.UPDATE } })
                    .then(function (addressInfo) {
                    if (addressInfo) {
                        _this.props.dispatchUpdateAddress(addressInfo);
                        if (_this.state.form.primary.value) {
                            _this.props.updateAction(VIEWS.ADDRESSES.TOAST_INTENTS.UPADTE_PRIMARY);
                        }
                        else {
                            _this.props.updateAction(VIEWS.ADDRESSES.TOAST_INTENTS.EDIT);
                        }
                    }
                    if (addressInfo.ppcSynchronyDeeplinks &&
                        Object.keys(addressInfo.ppcSynchronyDeeplinks).length !=
                            0) {
                        var ppcedit = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.ADDRESSES.EDIT_PPC;
                        page.redirect(ppcedit);
                    }
                    else {
                        var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.ADDRESSES.MANAGE;
                        page.redirect(url);
                    }
                })
                    .catch(function (error) {
                    _this.setState({ showSpinner: false });
                    var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, "statusCode") || 500;
                    var errorDescFPTI;
                    if (errorStatusCode >= 400 && errorStatusCode < 500) {
                        var code = addressErrors_1.errorCodes[error.errorKey];
                        var errorContent = _this.props.content.addresses.error[code];
                        if (!errorContent) {
                            errorContent = _this.getErrorContent(_this.props.commonContent.error.errorGeneric);
                        }
                        _this.setState({ errorMessage: errorContent });
                        errorDescFPTI = errorContent;
                    }
                    else {
                        var errorContent = _this.getErrorContent(_this.props.commonContent.error.errorGeneric);
                        _this.setState({ errorMessage: errorContent });
                        errorDescFPTI = errorContent;
                    }
                    triggerOperationResult_1.triggerOperationResult(_this.props.addressFpti.edit, FPTI.FAILURE, errorDescFPTI);
                    return;
                });
            }
        };
        var country_code = _this.props.addressData.newAddress.country;
        var validationError = _this.props.addressData.newAddress.entryMetadata
            .strings.validationError;
        var addressAll = _this.props.addressData.addresses;
        var updateAddressId = _this.props.route.enter.params.id;
        var addressToUpdate = addressAll.find(function (addr) { return addr.id === updateAddressId; });
        var layout = _this.props.addressData.newAddress.entryMetadata.layout;
        var stateList = _this.props.addressData.newAddress.entryMetadata.strings
            .stateList;
        var stateLabel = (stateList &&
            stateList.find(function (state) { return state.$id === addressToUpdate.state; })
                .$elt) ||
            " ";
        _this.state = {
            form: {
                line1: {
                    value: addressToUpdate.line1,
                    validation: {
                        required: true,
                        suggestionText: "Enter a valid street address",
                    },
                    isValid: true,
                    isTouched: false,
                },
                line2: {
                    value: addressToUpdate.line2,
                    validation: {
                        required: false,
                        suggestionText: " ",
                    },
                    isValid: true,
                    isTouched: false,
                },
                city: {
                    value: addressToUpdate.city,
                    validation: {
                        required: true,
                        suggestionText: "Enter a valid city name",
                    },
                    isValid: true,
                    isTouched: false,
                },
                state: {
                    value: addressToUpdate.state,
                    validation: {
                        required: true,
                        suggestionText: " ",
                    },
                    isValid: true,
                    isTouched: false,
                },
                postal_code: {
                    value: addressToUpdate.postalCode,
                    validation: {
                        required: layout.find(function (key) { return key.$ === "postcode"; }),
                        pattern: layout.find(function (key) { return key.$ === "postcode"; })
                            ? layout.find(function (key) { return key.$ === "postcode"; })
                                .validationPattern
                            : "",
                        maxlength: layout.find(function (key) { return key.$ === "postcode"; })
                            ? layout.find(function (key) { return key.$ === "postcode"; })
                                .maxLength
                            : null,
                        suggestionText: validationError,
                    },
                    isValid: true,
                    isTouched: false,
                },
                country_code: {
                    value: country_code,
                    validation: {
                        required: false,
                    },
                    isValid: true,
                    isTouched: false,
                },
                primary: {
                    value: addressToUpdate.primary !== "undefined"
                        ? addressToUpdate.primary
                        : false,
                    validation: {
                        required: false,
                    },
                    isValid: true,
                    isTouched: false,
                },
            },
            formIsValid: false,
            errorMessage: "",
            showSpinner: false,
            formChanged: false,
            addressToUpdate: addressToUpdate ? addressToUpdate : "",
            value: stateLabel,
            label: stateLabel,
            suggestions: stateList,
            openListPage: false,
        };
        return _this;
    }
    UpdateAddress.prototype.componentDidMount = function () {
        window.scroll({ top: 0, behavior: "smooth" });
    };
    UpdateAddress.prototype.checkValidity = function (value, rules) {
        var isValid = true;
        if (!rules) {
            return true;
        }
        if (rules.required) {
            isValid = value.trim() !== "" && isValid;
        }
        if (rules.maxLength) {
            isValid = value.length <= rules.maxLength && isValid;
        }
        if (rules.pattern) {
            // let pattern = rules.pattern;
            var pattern = new RegExp("^" + rules.pattern + "$");
            isValid = pattern.test(value) && isValid;
        }
        return isValid;
    };
    UpdateAddress.prototype.inputElement = function (key, strings, value) {
        var _this = this;
        var formElement = tslib_1.__assign({}, this.state.form[key.$]);
        var isInputValid = this.state.formChanged
            ? formElement.isValid || !formElement.isTouched
            : true;
        var disabled = this.state.showSpinner ||
            (this.state.addressToUpdate.billing &&
                this.state.addressToUpdate.cardList);
        if (key.$ === "line1") {
            return (React.createElement(pp_react_1.TextInput, { errorText: !isInputValid
                    ? formElement.validation.suggestionText
                    : "", disabled: disabled, id: key.$, className: "formFields_space", name: key.$, value: formElement.value, label: strings.line1Label, onChange: function (event) { return _this.inputChangedHandler(event, key.$); } }));
        }
        else if (key.$ === "line2") {
            return (React.createElement(pp_react_1.TextInput, { disabled: disabled, id: key.$, className: "formFields_space", name: key.$, value: formElement.value, label: strings.line2Label, onChange: function (event) { return _this.inputChangedHandler(event, key.$); } }));
        }
        else if (key.$ === "city") {
            if (strings.cityList) {
                return (React.createElement(pp_react_1.Dropdown, { disabled: disabled, className: "formFields_space", name: key.$, value: formElement.value, label: strings.cityLabel, placeholder: "", id: key.$, errorText: !isInputValid
                        ? formElement.validation.suggestionText
                        : "", options: strings.cityList.map(function (city) {
                        return {
                            label: city.$elt,
                            value: city.$id,
                        };
                    }), onChange: function (event) {
                        return _this.inputChangedHandler(event, key.$);
                    } }));
            }
            else {
                return (React.createElement(pp_react_1.TextInput, { errorText: !isInputValid
                        ? formElement.validation.suggestionText
                        : "", disabled: disabled, className: "formFields_space", id: key.$, name: key.$, value: formElement.value, label: strings.cityLabel, onChange: function (event) {
                        return _this.inputChangedHandler(event, key.$);
                    } }));
            }
        }
        else if (key.$ === "state") {
            if (strings.stateList) {
                return (React.createElement("div", null,
                    React.createElement(pp_react_1.Dropdown, { className: "formFields_space listPage_primary", errorText: "", disabled: disabled, value: formElement.value, name: key.$, label: strings.stateLabel, placeholder: "", id: key.$, options: strings.stateList.map(function (state) {
                            return {
                                label: state.$elt,
                                value: state.$id,
                            };
                        }), onChange: function (event) {
                            return _this.inputChangedHandler(event, key.$);
                        } }),
                    React.createElement(pp_react_1.Dropdown, { className: "formFields_space listPage_secondary", errorText: "", disabled: disabled, name: key.$, value: formElement.value, label: strings.stateLabel, placeholder: "", id: key.$, options: [
                            {
                                label: this.state.label,
                                value: this.state.value,
                            },
                        ], onClick: function (event) { return _this.toggleListPageVisibility(); } })));
            }
            else {
                return (React.createElement(pp_react_1.TextInput, { errorText: !isInputValid
                        ? formElement.validation.suggestionText
                        : "", disabled: disabled, className: "formFields_space", id: key.$, name: key.$, value: formElement.value, label: strings.stateLabel, onChange: function (event) {
                        return _this.inputChangedHandler(event, key.$);
                    } }));
            }
        }
        else if (key.$ === "postcode") {
            isInputValid = this.state.formChanged
                ? this.state.form.postal_code.isValid ||
                    !this.state.form.postal_code.isTouched
                : true;
            return (React.createElement(pp_react_1.TextInput, { errorText: !isInputValid
                    ? this.state.form.postal_code.validation
                        .suggestionText
                    : "", disabled: disabled, className: "formFields_space", id: "postal_code", name: "postal_code", value: this.state.form.postal_code.value, label: strings.postcodeLabel, onChange: function (event) {
                    return _this.inputChangedHandler(event, "postal_code");
                } }));
        }
    };
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    UpdateAddress.prototype.renderSuggestionsContainer = function (_a) {
        var containerProps = _a.containerProps, children = _a.children;
        return (React.createElement("div", null,
            React.createElement("div", { className: "listPage-divider" },
                React.createElement(pp_react_1.Divider, null)),
            React.createElement("div", { className: "suggestionContainer-body" },
                React.createElement("div", tslib_1.__assign({}, containerProps), children))));
    };
    UpdateAddress.prototype.render = function () {
        var _this = this;
        var formElementsArray = [];
        var addressFpti = this.props.addressFpti;
        for (var key in this.state.form) {
            formElementsArray.push({
                id: key,
                config: this.state.form[key],
            });
        }
        var layout = this.props.addressData.newAddress.entryMetadata.layout, layoutStrings = this.props.addressData.newAddress.entryMetadata
            .strings;
        var addressInput = layout.map(function (layoutitem, key) {
            return _this.inputElement(layoutitem, layoutStrings, _this.state.addressToUpdate);
        });
        //start : Autosuggestion related
        //@ts-ignore
        var _a = this.state, value = _a.value, suggestions = _a.suggestions;
        var inputProps = {
            value: value,
            type: "search",
            onChange: this.onChange,
            passValueToDropdown: this.passValueToDropdown,
        };
        function shouldRenderSuggestions(value) {
            return value.trim().length > -1;
        }
        //end Autosuggestion related
        var form = (React.createElement("form", { onSubmit: this.submitHandler },
            this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "form-alert" }, this.state.errorMessage)) : null,
            React.createElement(pp_react_1.Text, { className: "genericAccountHeader", size: "xl3" }, this.props.addressContent.edit.header),
            addressInput,
            !this.state.addressToUpdate.primary ? (
            // @ts-ignore
            React.createElement(pp_react_checkbox_1.Checkbox, { className: "checkbox_space", disabled: this.state.showSpinner, id: "primary", label: this.props.addressContent.addNewSetPrimary.checkBox, name: addressFpti.makePrimaryCheckbox, onChange: function (event) {
                    return _this.inputChangedHandler(event, "primary");
                } })) : null,
            this.state.addressToUpdate.billing ? (React.createElement("div", { className: "billingAddress-info" }, this.billingAddressInfo())) : null,
            React.createElement(pp_react_1.Button, { className: "addUpdateButton_space fullWidth", name: addressFpti.submitUpdate, type: "submit", disabled: this.state.showSpinner ||
                    (this.state.addressToUpdate.billing &&
                        this.state.addressToUpdate.primary &&
                        this.state.addressToUpdate.cardList) }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: "loading", inverse: true })) : (this.props.commonContent.update))));
        var listPage = (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement("table", { className: "listPageInput" },
                    React.createElement("tr", null,
                        React.createElement("td", { className: "listPageInput_space_left" }),
                        React.createElement("td", { className: "listPageInput_space_centre" },
                            React.createElement("div", null,
                                React.createElement(pp_react_1.Text, { size: "md", medium: true }, this.props.addressContent.select.state))),
                        React.createElement("td", { className: "listPageInput_space_right" },
                            React.createElement("div", { onClick: this.toggleListPageVisibility },
                                React.createElement(pp_react_1.Icon, { size: "sm", name: "close" })))))),
            React.createElement(Autosuggest, { suggestions: suggestions, onSuggestionsFetchRequested: this.onSuggestionsFetchRequested, getSuggestionValue: this.getSuggestionValue, renderSuggestion: this.renderSuggestion, focusInputOnSuggestionClick: false, inputProps: inputProps, renderSuggestionsContainer: this.renderSuggestionsContainer, shouldRenderSuggestions: shouldRenderSuggestions, alwaysRenderSuggestions: true, renderInputComponent: this.renderInput })));
        return (React.createElement("div", { className: "generic-container" }, !this.state.openListPage ? form : listPage));
    };
    return UpdateAddress;
}(React.Component));
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, links = _a.links, fpti = _a.fpti;
    var addressData = account.addressData, addressFpti = fpti.address, stateList = addressData.newAddress.entryMetadata.strings.stateList, addressContent = content.addresses, commonContent = content.common, showNavigation = account.showNavigation;
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        addressData: addressData,
        addressContent: addressContent,
        commonContent: commonContent,
        links: links,
        addressFpti: addressFpti,
        stateList: stateList,
        showNavigation: showNavigation,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchUpdateAddress: function (addressInfo) {
            return dispatch(addresses_1.buildAddress(addressInfo));
        },
        updateAction: function (typeOfAction) { return dispatch(addresses_1.actionType(typeOfAction)); },
        changeHeaderVisibility: function (value) { return dispatch(modalHeader_1.showNavigation(value)); },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UpdateAddress);
